import React from "react";
import { injectModels } from "../redux/injectModels";

const AuthLayout = (props) => {
  return <div>{props.children}</div>;
};

export default injectModels(["auth"])(AuthLayout);
